<ng-container *ngIf="!error">
    <div class="revoked-container">
        <h2>Votre revoquation a bien été pris en compte ✅</h2>
        <p>
            Vous avez choisi de ne pas donner ou de révoquer votre consentement pour le partage des
            données de votre compteur.
        </p>

        <p>
            Vos données précédentes sont supprimées et aucune information ne sera transmise à notre
            application.
        </p>
    </div>
</ng-container>

<ng-container *ngIf="!!error">
    <div class="container my-5">
        <div class="alert alert-danger">
            <h2>Lien du refus du consentement invalide ou expiré ❌</h2>
            <p class="mb-0">
                Le lien que vous avez utilisé n’est plus valide. Veuillez contacter
                l’administrateur.
            </p>
        </div>
    </div>
</ng-container>
